// src/services/api/shops.js
import { apiClient } from './base';

export const createShop = async (shopData) => {
  try {
    const response = await apiClient.post('/shops', shopData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getShops = async (params = {}) => {
  try {
    const response = await apiClient.get('/shops', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getShop = async (shopId) => {
  try {
    const response = await apiClient.get(`/shops/${shopId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateShop = async (shopId, shopData) => {
  try {
    const response = await apiClient.put(`/shops/${shopId}`, shopData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteShop = async (shopId) => {
  try {
    const response = await apiClient.delete(`/shops/${shopId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const checkOrderPrefix = async (prefix) => {
  try {
    const response = await apiClient.get(`/shops/check-prefix?prefix=${encodeURIComponent(prefix)}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const checkCatalogSlug = async (slug, shopId = null) => {
  try {
    const params = new URLSearchParams({ slug: slug.toLowerCase().trim() });
    if (shopId) params.set('shopId', shopId);
    const response = await apiClient.get(`/shops/check-catalog-slug?${params}`);
    return response.data; // { available: boolean, normalised: string } or { available: false, reason: string }
  } catch (error) {
    throw error;
  }
};

export const updateShopStatus = async (shopId, status) => {
  try {
    const response = await apiClient.patch(`/shops/${shopId}/status`, { status });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Product assignments
export const getShopAssignedProducts = async (shopId, params = {}) => {
  const response = await apiClient.get(`/shops/${shopId}/products`, { params });
  return response.data;
};

export const assignProductsToShop = async (shopId, items) => {
  const response = await apiClient.post(`/shops/${shopId}/products`, { items });
  return response.data;
};

export const updateShopProduct = async (shopId, productShopId, data) => {
  const response = await apiClient.put(`/shops/${shopId}/products/${productShopId}`, data);
  return response.data;
};

export const removeShopProduct = async (shopId, productShopId) => {
  const response = await apiClient.delete(`/shops/${shopId}/products/${productShopId}`);
  return response.data;
};

// User assignments
export const getShopAssignedUsers = async (shopId) => {
  const response = await apiClient.get(`/shops/${shopId}/users`);
  return response.data;
};

export const assignUsersToShop = async (shopId, userIds) => {
  const response = await apiClient.post(`/shops/${shopId}/users`, { userIds });
  return response.data;
};

export const removeShopUser = async (shopId, userId) => {
  const response = await apiClient.delete(`/shops/${shopId}/users/${userId}`);
  return response.data;
};

// WooCommerce webhook provisioning
export const enableWoocommerceWebhook = async (shopId) => {
  const response = await apiClient.post(`/shops/${shopId}/woocommerce-webhook/enable`);
  return response.data;
};

export const disableWoocommerceWebhook = async (shopId) => {
  const response = await apiClient.post(`/shops/${shopId}/woocommerce-webhook/disable`);
  return response.data;
};

export const regenerateWoocommerceWebhookSecret = async (shopId) => {
  const response = await apiClient.post(`/shops/${shopId}/woocommerce-webhook/regenerate`);
  return response.data;
};
// WooCommerce REST API credentials + manual order sync
export const saveWoocommerceApiCredentials = async (shopId, credentials) => {
  const response = await apiClient.put(`/shops/${shopId}/woocommerce-api`, credentials);
  return response.data;
};

export const testWoocommerceConnection = async (shopId) => {
  const response = await apiClient.post(`/shops/${shopId}/woocommerce-api/test`);
  return response.data;
};

export const getWoocommerceSyncShops = async () => {
  const response = await apiClient.get('/shops/woocommerce-sync/eligible');
  return response.data;
};

export const syncWoocommerceOrder = async (shopId, wooCommerceOrderId) => {
  const response = await apiClient.post(`/shops/${shopId}/woocommerce-sync/order`, { wooCommerceOrderId });
  return response.data;
};

// Date syncs can run for a while (up to 500 orders) — allow a long timeout
export const syncWoocommerceOrdersByDate = async (shopId, date) => {
  const response = await apiClient.post(`/shops/${shopId}/woocommerce-sync/date`, { date }, { timeout: 300000 });
  return response.data;
};
